export default "https://storage.googleapis.com/prepweb-prod/dist/8be7827589ce64ee7f917f65a4615fe3.svg";